/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const PasswordLoginBody = zod.object({
  app: zod
    .enum(['onearly', 'strongermemory'])
    .optional()
    .describe(
      "The app signing in. Core mints the tokens for that app's own Ory client where this deployment has one, else for the OnEarly app's. The access token names the client in `client_id`: refresh and revoke at Ory with that client. Defaults to `onearly`, so existing clients need not send it. It also decides whose sign-up regions apply: a request naming `onearly` takes everyone's, whatever headers it carries.",
    ),
  identifier: zod.email(),
  password: zod.string().min(1),
});

export type PasswordLoginBody = zod.input<typeof PasswordLoginBody>;
export type PasswordLoginBodyOutput = zod.output<typeof PasswordLoginBody>;
